import React from 'react';
export default function CopyLink() {
  return (
    <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9 17H6A5 5 0 1 1 6 7h3m6 0h3a5 5 0 1 1 0 10h-3V7ZM8 12h4"
        stroke="#fff"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
